/**
 * Resolve the backend WS base URL. Mirrors the WhatIs / Anagram version
 * exactly so the deploy pipeline can use one strategy for all browser sources.
 */
export function resolveWsBase(wsPort: number): string {
  const envUrl = (import.meta.env as Record<string, string | undefined>).VITE_BACKEND_WS_URL;
  if (envUrl) return envUrl.replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    const host = window.location.host;
    const apex = host.split('.').slice(-2).join('.');
    return `wss://api.${apex}`;
  }
  return `ws://${window.location.hostname}:${wsPort}`;
}
